import { RegistrationTemplate } from './template';

export const Registration = () => <RegistrationTemplate />;
